import { render } from "./followRecordEdit.vue?vue&type=template&id=99a58d16&scoped=true"
import script from "./followRecordEdit.vue?vue&type=script&lang=js"
export * from "./followRecordEdit.vue?vue&type=script&lang=js"

import "./followRecordEdit.vue?vue&type=style&index=0&id=99a58d16&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a58d16"]])

export default __exports__